module.exports = __webpack_public_path__ + "img/sensors-and-actuators.5fc1f461.webp";